import { MutiSelectTable } from './MutiSelectTable'
import { withMutiSelectTable } from './withMutiSelectTable'

const ConnectedMutiSelectTable = withMutiSelectTable(MutiSelectTable)

export { ConnectedMutiSelectTable as MutiSelectTable }
